import script from "./recordSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./recordSearch.vue?vue&type=script&lang=ts&setup=true"

import "./recordSearch.vue?vue&type=style&index=0&id=b14e81e2&scoped=true&lang=css"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b14e81e2"]])

export default __exports__